<template src="./Psoriasis.html"> </template>

<script>
import ContentBase from './ContentBase.vue';
import { mapState } from 'vuex';
import { psoriasis as menuItems } from '@/data/sections';
// import { debounce } from 'lodash';

export default {
  mixins: [ContentBase],
  data() {
    return {
      menuItems
    };
  },
  computed: {
    ...mapState(['userAgent'])
  },
  methods: {
    clickArrowToTremfya() {
      this.$store.state.psoriasisScrollPos = 0;
      this.$store.state.tremfyaScrollPos = 0;

      this.$router.push('/tremfya/1/', () => {
        this.$store.state.psoriasisScrollPos = 0;
        document.body.scrollTop = 0;
        window.scrollTo(0, 0);
      });
    }
  }
};
</script>

<style scoped>
</style>
